import React from 'react';
import { withBlockExtensions } from '@plone/volto/helpers';
import { SidebarPortal } from '@plone/volto/components';

import View from './View';
import Data from './Data';

/**
 * Editor do bloco "Galeria de imagens". Ver `Blocks/SubHomeGaleria/Edit.tsx`:
 * o índice da foto em edição nasce aqui e alimenta o lápis (View) e o acordeão
 * do `object_list` (Data).
 */
const Edit = (props) => {
  const { block, data, onSelectBlock, selected } = props;
  const [activeItem, setActiveItem] = React.useState(-1);

  const handleEditItem = React.useCallback(
    (index: number) => {
      // Sem selecionar o bloco, o `SidebarPortal` nem monta o formulário.
      onSelectBlock?.(block);
      setActiveItem(index);
    },
    [block, onSelectBlock],
  );

  return (
    <>
      <View {...props} data={data} onEditItem={handleEditItem} />

      <SidebarPortal selected={selected}>
        <Data
          {...props}
          activeObject={activeItem}
          setActiveObject={setActiveItem}
        />
      </SidebarPortal>
    </>
  );
};

export default withBlockExtensions(Edit);
